import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {generateLabelShip, generateLabelByLabelId} from "../../../services/api/apiNextBarcode"
import Button from "reactstrap/es/Button"
import Promise from 'bluebird'

class BulkGenLabelModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: ''
        }
    }

    componentDidMount = async () => {
        await this._genListItems()
        await this._genAllLabels()
    }

    _genAllLabels = () => {
        const {listItems} = this.state

        this._genLabels(listItems)
    }

    _genListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _genLabels = async (listItems) => {
        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        await Promise.each(listItems, async item => {
            this.setState({
                itemLoading: item._id
            })

            try {
                const rawId = item.meta && item.meta.label && item.meta.label.id
                const labelId = rawId && /^[a-f\d]{24}$/i.test(String(rawId))
                    ? rawId
                    : item.meta && item.meta.label && item.meta.label._id
                let success, message

                if (labelId) {
                    // Luồng MỚI
                    const result = await generateLabelByLabelId(labelId, { trigger: 'manual-bulk' })
                    success = result.success
                    message = result.message
                } else {
                    // Luồng CŨ
                    const payload = {
                        status: item.gen_at !== undefined ? 'regenerated' : 'generated',
                        action: 'bulk'
                    }
                    const result = await generateLabelShip(item._id, payload)
                    success = result.success
                    message = result.message
                }

                let {itemError, itemsSuccess} = this.state

                if (success) {

                    itemsSuccess.push(item._id)

                    this.setState({
                        itemsSuccess: itemsSuccess,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                } else {
                    itemError.push({
                        _id: item._id,
                        message: message
                    })

                    this.setState({
                        itemError: itemError,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }
            } catch (e) {
                let {itemError, itemsSuccess} = this.state

                this.setState({
                    itemError: e.message,
                    itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                })
            }

        })
    }

    _genItemLabel = async (item) => {
        try {
            const {itemsSuccess, itemError} = this.state
            const rawId = item.meta && item.meta.label && item.meta.label.id
            const labelId = rawId && /^[a-f\d]{24}$/i.test(String(rawId))
                ? rawId
                : item.meta && item.meta.label && item.meta.label._id
            let success, message

            if (labelId) {
                const result = await generateLabelByLabelId(labelId, { trigger: 'manual' })
                success = result.success
                message = result.message
            } else {
                const payload = {
                    status: item.gen_at !== undefined ? 'regenerated' : 'generated'
                }
                const result = await generateLabelShip(item._id, payload)
                success = result.success
                message = result.message
            }

            if (success) {
                itemsSuccess.push(item._id)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                })
            } else {
                const newItemErr = itemError.map(itemNew => {
                    if (itemNew._id === item._id) {
                        return {
                            ...itemNew,
                            message: message
                        }
                    }
                    return itemNew
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(itemNew => {
            return itemNew._id === item._id ? {
                ...itemNew,
                message: ''
            } : itemNew
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: item._id
        })

        this._genItemLabel(item)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._genLabels(itemError)
    }

    _showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Order generated success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    render() {
        const {isOpen, handleToggleModal} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError} = this.state

        return (
            <div>
                <Modal isOpen={isOpen} className="BulkGenLabels"
                >
                    <ModalHeader>
                        Bulk gen label
                    </ModalHeader>
                    <ModalBody>
                        <div className="ListGenLabels">
                            {listItems.length > 0 && (
                                listItems.map(item => {
                                    return (
                                        <div key={item._id} className="ItemGenLabel d-sm-flex mb-2 pb-2">
                                            <div className="IconStatus mr-2">
                                                {itemsSuccess.includes(item._id) && (
                                                    <i className="icon-check text-success"/>
                                                )}
                                                {
                                                    (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                        <i className="icon-cross text-danger"/>
                                                    )
                                                }
                                            </div>
                                            <div className="ContentGenLabel">
                                                <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                {
                                                    (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                        <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                    )
                                                }
                                                {itemLoading === item._id &&
                                                <i className='icon-spinner2 spinner ml-2'/>}
                                                {this._showMessage(itemError, itemsSuccess, item._id)}
                                            </div>
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            {itemError.length > 0 && (
                                <Button onClick={this._retryAll} className="bg-danger"><i
                                    className="icon-spinner11 mr-1"/> Retry all</Button>
                            )}
                            <Button disabled={itemLoading} onClick={handleToggleModal} className="bg-primary ml-2">
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

}

export default BulkGenLabelModal
